import { Component, OnInit } from '@angular/core';
import { MyStorageService } from "../../services/common/my-storage.service";
import { MenuService } from "../../services/menu.service";

export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  isCollapsed?: boolean;
  isCollapsing?: any;
  children?: ChildrenItems[];
  visible: boolean;
}

export interface ChildrenItems {
  path: string;
  title: string;
  smallTitle?: string;
  type?: string;
  collapse?: string;
  children?: ChildrenItems2[];
  isCollapsed?: boolean;
  visible: boolean;
}

export interface ChildrenItems2 {
  path?: string;
  smallTitle?: string;
  title?: string;
  type?: string;
  visible: boolean;
}

// Menu Items
export const ROUTES: RouteInfo[] = [
  {
    path: '/',
    title: 'menu.main',
    type: 'link',
    icontype: 'tim-icons icon-chart-pie-36',
    visible: false
  },
  {
    path: '/reservations',
    title: 'menu.reservation.main',
    type: 'sub',
    icontype: 'tim-icons icon-basket-simple',
    collapse: 'orders',
    isCollapsed: true,
    children: [
      {
        path: 'delivery',
        title: 'menu.order.delivery',
        type: 'link',
        smallTitle: 'D',
        visible: false
      },
      {
        path: 'restaurant',
        title: 'menu.order.restaurant',
        type: 'link',
        smallTitle: 'D',
        visible: false
      },

      {
        path: 'event',
        title: 'menu.order.event',
        type: 'link',
        smallTitle: 'D',
        visible: false
      },
      // {
      //   path: 'all',
      //   title: 'menu.order.all',
      //   type: 'link',
      //   smallTitle: 'A',
      //   visible: false
      // }
    ],
    visible: false
  },
  {
    path: '/orders',
    title: 'menu.order.main',
    type: 'sub',
    icontype: 'tim-icons icon-basket-simple',
    collapse: 'orders',
    isCollapsed: true,
    children: [
      {
        path: 'shop-orders',
        title: 'menu.order.all',
        type: 'link',
        smallTitle: 'O',
        visible: false
      },
      {
        path: 'discounts',
        title: 'menu.order.discount',
        type: 'link',
        smallTitle: 'Dc',
        visible: false
      }
      ,
      {
        path: 'supports',
        title: 'menu.order.supportMessage',
        type: 'link',
        smallTitle: 'Dc',
        visible: false
      },
      {
        path: 'reviews',
        title: 'menu.order.reviews',
        type: 'link',
        smallTitle: 'Dc',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/products',
    title: 'menu.product.main',
    type: 'sub',
    icontype: 'tim-icons icon-basket-simple',
    collapse: 'products',
    isCollapsed: true,
    children: [
      {
        path: 'gift_card',
        title: 'menu.product.giftcard',
        type: 'link',
        smallTitle: 'Gc',
        visible: false
      },
      {
        path: 'product',
        title: 'menu.product.common',
        type: 'link',
        smallTitle: 'Gc',
        visible: false
      },
      {
        path: 'drink',
        title: 'menu.product.drink',
        type: 'link',
        smallTitle: 'Gc',
        visible: false
      },
      {
        path: 'food',
        title: 'menu.product.food',
        type: 'link',
        smallTitle: 'Gc',
        visible: false
      },
      {
        path: 'extra',
        title: 'menu.product.extra',
        type: 'link',
        smallTitle: 'Gc',
        visible: false
      },
      {
        path: 'package',
        title: 'menu.product.package',
        type: 'link',
        smallTitle: 'Gc',
        visible: false
      },
      {
        path: 'event',
        title: 'menu.product.event',
        type: 'link',
        smallTitle: 'Gc',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/administration',
    title: 'menu.administration.main',
    type: 'sub',
    icontype: 'tim-icons icon-badge',
    collapse: 'administration',
    isCollapsed: true,
    children: [
      {
        path: 'restaurant',
        title: 'menu.administration.restaurant',
        type: 'link',
        smallTitle: 'R',
        visible: false
      },
      {
        path: 'company',
        title: 'menu.administration.company',
        type: 'link',
        smallTitle: 'R',
        visible: false
      },
      {
        path: 'user-management',
        title: 'menu.administration.userManagement',
        type: 'link',
        smallTitle: 'UM',
        visible: false
      },
      {
        path: 'dashboard-message',
        title: 'menu.administration.dashboardMessage',
        type: 'link',
        smallTitle: 'DM',
        visible: false
      },
      {
        path: 'subscribed-users',
        title: 'menu.administration.subscribedUsers',
        type: 'link',
        smallTitle: 'SU',
        visible: false
      },
      {
        path: 'diy-carte-pattern',
        title: 'menu.administration.cartePattern',
        type: 'link',
        smallTitle: 'UM',
        visible: false
      },
      {
        path: 'drink-carte-pattern',
        title: 'menu.administration.drinkCartePattern',
        type: 'link',
        smallTitle: 'UM',
        visible: false
      },
      {
        path: 'drink',
        title: 'menu.administration.drink',
        type: 'link',
        smallTitle: 'D',
        visible: false
      },

      {
        path: 'kitchen',
        isCollapsed: true,
        title: 'menu.administration.kitchen.menuTitle',
        type: 'sub',
        smallTitle: 'SL',
        collapse: 'system-lists',
        children: [
          {
            path: 'necessary_equipments',
            title: 'menu.administration.kitchen.necessary_equipments',
            type: 'link',
            smallTitle: 'DR',
            visible: false
          },
          {
            path: 'diets',
            title: 'menu.administration.kitchen.diets',
            type: 'link',
            smallTitle: 'PL',
            visible: false
          },
          {
            path: 'allergens',
            title: 'menu.administration.kitchen.allergens',
            type: 'link',
            smallTitle: 'DT',
            visible: false
          },
          {
            path: 'cuisines',
            title: 'menu.administration.kitchen.cuisines',
            type: 'link',
            smallTitle: 'I',
            visible: false
          },
          {
            path: 'ingredients',
            title: 'menu.administration.kitchen.ingredients',
            type: 'link',
            smallTitle: 'S',
            visible: false
          }
        ],
        visible: false
      },
      {
        path: 'core-data',
        isCollapsed: true,
        title: 'menu.administration.coreData.menuTitle',
        type: 'sub',
        smallTitle: 'R',
        collapse: 'core-data',
        children: [
          {
            path: 'languages',
            title: 'menu.administration.coreData.languages',
            type: 'link',
            smallTitle: 'DR',
            visible: false
          },
          {
            path: 'localizations',
            title: 'menu.administration.coreData.localizations',
            type: 'link',
            smallTitle: 'DR',
            visible: false
          },
          {
            path: 'currencies',
            title: 'menu.administration.coreData.currencies',
            type: 'link',
            smallTitle: 'DR',
            visible: false
          },
        ],
        visible: false
      },
      {
        path: 'system-lists',
        isCollapsed: true,
        title: 'menu.administration.systemLists.menuTitle',
        type: 'sub',
        smallTitle: 'SL',
        collapse: 'system-lists',
        children: [
          {
            path: 'DRINK_TYPE',
            title: 'menu.administration.systemLists.drinkType',
            type: 'link',
            smallTitle: 'DR',
            visible: false
          },
          {
            path: 'PRODUCT_LEVEL',
            title: 'menu.administration.systemLists.productLevel',
            type: 'link',
            smallTitle: 'PL',
            visible: false
          },
          {
            path: 'DIY_TYPE',
            title: 'menu.administration.systemLists.diyType',
            type: 'link',
            smallTitle: 'DT',
            visible: false
          },
          {
            path: 'INGREDIENT_TYPE',
            title: 'menu.administration.systemLists.ingredientType',
            type: 'link',
            smallTitle: 'I',
            visible: false
          },
          {
            path: 'STAFF_TYPE',
            title: 'menu.administration.systemLists.staffType',
            type: 'link',
            smallTitle: 'S',
            visible: false
          },
          {
            path: 'DOCUMENT_TYPE',
            title: 'menu.administration.systemLists.documentType',
            type: 'link',
            smallTitle: 'DO',
            visible: false
          },
          {
            path: 'NECESSARY_EQUIPMENT_TYPE',
            title: 'menu.administration.systemLists.necessaryEquipmentType',
            type: 'link',
            smallTitle: 'NE',
            visible: false
          }
        ],
        visible: false
      },
      {
        path: 'menu-items',
        title: 'menu.administration.menuItems',
        type: 'link',
        smallTitle: 'MI',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/restaurant',
    title: 'menu.restaurant.main',
    type: 'sub',
    icontype: 'tim-icons icon-istanbul',
    collapse: 'restaurant',
    isCollapsed: true,
    children: [
      {
        path: 'place',
        title: 'menu.restaurant.place',
        type: 'link',
        smallTitle: 'S',
        visible: false
      },
      {
        path: 'staff',
        title: 'menu.restaurant.staff',
        type: 'link',
        smallTitle: 'S',
        visible: false
      },
      {
        path: 'opening-hours',
        title: 'menu.restaurant.opening',
        type: 'link',
        smallTitle: 'OH',
        visible: false
      },
      {
        path: 'closing-hours',
        title: 'menu.restaurant.closing',
        type: 'link',
        smallTitle: 'CH',
        visible: false
      },
      {
        path: 'carte',
        title: 'menu.restaurant.carte',
        type: 'link',
        smallTitle: 'CA',
        visible: false
      },
      {
        path: 'drink-carte',
        title: 'menu.restaurant.drinkCarte',
        type: 'link',
        smallTitle: 'DC',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/analytics',
    title: 'menu.analitics.main',
    type: 'sub',
    icontype: 'tim-icons icon-chart-pie-36',
    collapse: 'analytics',
    isCollapsed: true,
    children: [
      {
        path: 'recent-statistics',
        title: 'menu.analitics.recent',
        type: 'link',
        smallTitle: 'R',
        visible: false
      },
      {
        path: 'accounts',
        title: 'menu.analitics.accounts',
        type: 'link',
        smallTitle: 'MI',
        visible: false
      },
      {
        path: 'reservations',
        title: 'menu.analitics.reservations',
        type: 'link',
        smallTitle: 'MI',
        visible: false
      },
      {
        path: 'sales-analytics',
        title: 'menu.analytics.sales',
        type: 'link',
        smallTitle: 'MI',
        visible: false
      }
      /*
      ,
      {
          path: 'shop',
          title: 'menu.analitics.shop',
          type: 'link',
          smallTitle: 'Sh',
          visible: false
      },
      {
          path: 'delivery',
          title: 'menu.analitics.delivery',
          type: 'link',
          smallTitle: 'D',
          visible: false
      }*/
    ],
    visible: false
  },
  {
    path: '/diys',
    title: 'menu.diys.main',
    type: 'sub',
    icontype: 'tim-icons icon-puzzle-10',
    collapse: 'fees',
    isCollapsed: true,
    children: [
      {
        path: 'diy',
        title: 'menu.diys.diy',
        type: 'link',
        smallTitle: 'D',
        visible: false
      },
      {
        path: 'video-event',
        title: 'menu.diys.videoEvent',
        type: 'link',
        smallTitle: 'E',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/attachments',
    title: 'menu.attachment.main',
    type: 'sub',
    icontype: 'tim-icons icon-image-02',
    collapse: 'attachments',
    isCollapsed: true,
    children: [
      {
        path: 'available',
        title: 'menu.attachment.attachment',
        type: 'link',
        smallTitle: 'AA',
        visible: false
      },
      {
        path: 'frontend',
        title: 'menu.attachment.frontend',
        type: 'link',
        smallTitle: 'DA',
        visible: false
      },
      {
        path: 'deletable',
        title: 'menu.attachment.deletable',
        type: 'link',
        smallTitle: 'DA',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/vouchers',
    title: 'menu.vouchers.main',
    type: 'sub',
    icontype: 'tim-icons icon-gift-2',
    isCollapsed: true,
    collapse: 'vouchers',
    children: [
      {
        path: 'vouchers',
        title: 'menu.vouchers.vouchers',
        type: 'link',
        smallTitle: 'DA',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/email',
    title: 'menu.email.main',
    type: 'sub',
    icontype: 'tim-icons icon-email-85',
    collapse: 'administration',
    isCollapsed: true,
    children: [
      {
        path: 'to-admin',
        isCollapsed: true,
        title: 'menu.email.admin.menuTitle',
        type: 'sub',
        smallTitle: 'EA',
        collapse: 'email-admin',
        children: [
          {
            path: 'reservation',
            title: 'menu.email.admin.reservation',
            type: 'link',
            smallTitle: 'RE',
            visible: false
          },
          {
            path: 'order',
            title: 'menu.email.admin.order',
            type: 'link',
            smallTitle: 'OR',
            visible: false
          },
          {
            path: 'support',
            title: 'menu.email.admin.support',
            type: 'link',
            smallTitle: 'SU',
            visible: false
          },
          {
            path: 'delivery',
            title: 'menu.email.admin.delivery',
            type: 'link',
            smallTitle: 'DE',
            visible: false
          }
        ],
        visible: false
      },
      {
        path: 'to-user',
        isCollapsed: true,
        title: 'menu.email.user.menuTitle',
        type: 'sub',
        smallTitle: 'EA',
        collapse: 'email-user',
        children: [
          {
            path: 'reservation',
            title: 'menu.email.user.reservation',
            type: 'link',
            smallTitle: 'RE',
            visible: false
          },
          {
            path: 'guest',
            title: 'menu.email.user.guest',
            type: 'link',
            smallTitle: 'RE',
            visible: false
          },
          {
            path: 'order',
            title: 'menu.email.user.order',
            type: 'link',
            smallTitle: 'OR',
            visible: false
          },
          {
            path: 'support',
            title: 'menu.email.user.support',
            type: 'link',
            smallTitle: 'SU',
            visible: false
          },
          {
            path: 'delivery',
            title: 'menu.email.user.delivery',
            type: 'link',
            smallTitle: 'DE',
            visible: false
          }
        ],
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/translation',
    title: 'menu.translation.main',
    type: 'sub',
    icontype: 'tim-icons icon-paper',
    collapse: 'translations',
    isCollapsed: true,
    children: [
      {
        path: 'translation',
        title: 'menu.translation.environments',
        type: 'sub',
        smallTitle: 'TR',
        visible: false,
        children: [
          {
            path: 'dashboard',
            title: 'menu.translation.dashboard',
            type: 'link',
            smallTitle: 'DaT',
            visible: false
          },
          {
            path: 'delivery',
            title: 'menu.translation.delivery',
            type: 'link',
            smallTitle: 'DeT',
            visible: false
          },
          {
            path: 'shop',
            title: 'menu.translation.shop',
            type: 'link',
            smallTitle: 'WsT',
            visible: false
          },
          {
            path: 'food-selector',
            title: 'menu.translation.menu',
            type: 'link',
            smallTitle: 'MT',
            visible: false
          },
          {
            path: 'email',
            title: 'menu.translation.email',
            type: 'link',
            smallTitle: 'EM',
            visible: false
          },
          {
            path: 'restaurant',
            title: 'menu.translation.restaurantApp',
            type: 'link',
            smallTitle: 'RE',
            visible: false
          },
          {
            path: 'error',
            title: 'menu.translation.error',
            type: 'link',
            smallTitle: 'ET',
            visible: false
          },
          {
            path: 'banner',
            title: 'menu.translation.banners',
            type: 'link',
            smallTitle: 'BN',
            visible: false
          },
          {
            path: 'mobile',
            title: 'menu.translation.mobile',
            type: 'link',
            smallTitle: 'MA',
            visible: false
          }
        ]
      },
      {
        path: 'banner',
        title: 'menu.translation.banners',
        type: 'sub',
        smallTitle: 'BN',
        visible: false,
        children: [

          {
            path: 'delivery',
            title: 'menu.translation.banner.delivery',
            type: 'link',
            smallTitle: 'DeT',
            visible: false
          },
          {
            path: 'shop',
            title: 'menu.translation.banner.shop',
            type: 'link',
            smallTitle: 'WsT',
            visible: false
          },
          {
            path: 'food-selector',
            title: 'menu.translation.banner.menu',
            type: 'link',
            smallTitle: 'MT',
            visible: false
          }
        ]
      },
    ],
    visible: false
  },
  {
    path: '/fees',
    title: 'menu.fee.main',
    type: 'sub',
    icontype: 'tim-icons icon-coins',
    collapse: 'fees',
    isCollapsed: true,
    children: [
      {
        path: 'fee',
        title: 'menu.fee.fee',
        type: 'link',
        smallTitle: 'F',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/links',
    title: 'menu.links.main',
    type: 'sub',
    icontype: 'tim-icons icon-coins',
    collapse: 'fees',
    isCollapsed: true,
    children: [
      {
        path: 'moodle',
        title: 'menu.links.moodle',
        type: 'link',
        smallTitle: 'F',
        visible: false
      }
    ],
    visible: false
  },
  {
    path: '/logs',
    title: 'menu.logs.main',
    type: 'sub',
    icontype: 'tim-icons icon-paper',
    collapse: 'translations',
    isCollapsed: true,
    children: [
      {
        path: 'vouchers',
        title: 'menu.logs.voucher',
        type: 'link',
        smallTitle: 'VeL',
        visible: false
      },
      {
        path: 'products',
        title: 'menu.logs.prodct',
        type: 'link',
        smallTitle: 'Pel',
        visible: false
      },
      {
        path: 'fees',
        title: 'menu.logs.fee',
        type: 'link',
        smallTitle: 'Fel',
        visible: false
      },
      {
        path: 'scheduled',
        title: 'menu.logs.scheduler',
        type: 'link',
        smallTitle: 'Sel',
        visible: false
      },
      {
        path: 'reservations',
        title: 'menu.logs.reservations',
        type: 'link',
        smallTitle: 'Sel',
        visible: false
      }
    ],
    visible: false
  }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  turnOffMenuItemsCheck: boolean;

  constructor(private menuService: MenuService,
              private myStorage: MyStorageService) {
  }

  ngOnInit() {
    this.turnOffMenuItemsCheck = this.myStorage.checkKey('turnOffMenuItemsCheck');
    if (this.turnOffMenuItemsCheck) {
      this.menuItems = this.menuService.enableFullSideBar(ROUTES);
    } else {
      this.menuService.getLoggedInUserWithMenuItems().subscribe(response => {
        this.menuItems = this.menuService.createFilteredSideBar(ROUTES, response.menuItems);
      });
    }
  }
}

